module.exports = __webpack_public_path__ + "img/fails.222bb66f.png";